<template>
    <div class="operationLogPage">
        <headerNotice routerName="操作日志"></headerNotice>
        <!-- 搜索条 -->
        <div class="searchBox">
            <el-form
                :inline="true"
                :model="operationLogSearchForm"
                class="demo-form-inline searchForm"
            >
                <el-form-item label="操作人员">
                    <el-select
                        v-model="operationLogSearchForm.operationUser"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option v-for='item in option' 
                            :label="item.operationRealName" 
                            :value="item.operationUser"
                            :key='item.operationUser'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作日期">
                    <el-date-picker
                        v-model="operationLogSearchForm.operationTime"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click='onSearch'>搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 搜索结果列表 -->
        <div class="searchList" v-loading="loading">
            <div class="searchListHead">
                <h2 class="searchListTitle">
                    <i></i>
                    <span>数据列表</span>
                </h2>
                <div class="searchListCtl">
                    <el-select v-model="delDays" placeholder="选择清除日期" clearable>
                        <el-option label="一周之前" :value="7"></el-option>
                        <el-option label="一个月之前" :value="30"></el-option>
                        <el-option label="三个月之前" :value="90"></el-option>
                        <el-option label="半年之前" :value="182"></el-option>
                        <el-option label="一年之前" :value="365"></el-option>
                    </el-select>
                    <el-button @click='deleteDays'>确定删除</el-button>
                </div>
            </div>
            <div class="searchListContent">
                <el-table
                    ref="searchListTable"
                    :data="searchListTableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="customerSlelectionChange"
                    border
                >
                    <el-table-column align='center' type="selection" width="55"></el-table-column>
                    <el-table-column align='center' prop="logID" label="编号" width="120"></el-table-column>
                    <el-table-column align='center' prop="operationRealName" label="操作者" width="200"></el-table-column>
                    <el-table-column align='center' prop="operationTime" label="操作日期" width="200"></el-table-column>
                    <el-table-column align='center' prop="ip" label="IP地址" width="200"></el-table-column>
                    <el-table-column align='center' prop="remarks" label="操作记录"></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="btn-wrapper" style='margin-left:50px;'>
            <el-button @click='delRecord'>批量删除</el-button>
        </div>
        <!--搜索列表分页-->
            <el-pagination
                align='center'
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: true,
      optionLoading: false,
      totalCount: 0, //总数据条数
      maxResultCount: 10, //默认一页显示的个数,
      currentPage: 1,
      operationLogSearchForm: {
        operationUser: "",
        operationTime: ""
      },
      delDays: "",
      searchListTableData: [],
      customerSlelection: [],
      option: []
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas({
      MaxResultCount: this.maxResultCount
    });
    this.getOption();
  },
  methods: {
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOperationLog/GetList",
        params: params,
        success(res) {
          self.searchListTableData = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          // console.log(res);
          self.loading = false;
        }
      });
    },
    // 选项
    getOption() {
      let self = this;
      self.optionLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOperationLog/GetOperator",
        // params: params,
        success(res) {
          // console.log(res)
          self.option = res;
          self.optionLoading = false;
        },
        fail(res) {
          // console.log(res);
          self.optionLoading = false;
        }
      });
    },
    // 删除--按日期
    deleteDays() {
      let self = this;
      this.$confirm("此操作将永久删除该日期内的记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminOperationLog/DeleteDays",
            params: { days: self.delDays },
            success(res) {
              self.$message.success("操作成功！");
              // self.getDatas({
              //     maxResultCount: self.maxResultCount
              // })
              self.onSearch();
            },
            fail(res) {
              // console.log(res);
              // self.loading = false;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 批量删除
    delRecord() {
      let self = this;
      this.$confirm("此操作将永久删除选中的记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let logIDs = [];
          self.customerSlelection.forEach(item => {
            logIDs.push("logIDs=" + item.logID);
          });
          let search = logIDs.join("&");
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminOperationLog/Delete?" +
              search,
            // params: {logIDs: logIDs},
            success(res) {
              self.$message.success("操作成功！");
              // self.getDatas({
              //     maxResultCount: self.maxResultCount
              // })
              self.onSearch();
            },
            fail(res) {
              console.log(res);
              // self.loading = false;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //搜索
    onSearch(params) {
      let self = this;
      let form = {
        maxResultCount: this.maxResultCount
      };
      let operationUser = this.operationLogSearchForm.operationUser;
      let operationTime = this.operationLogSearchForm.operationTime;
      if (operationUser != "") form.operationUser = operationUser;
      if (operationTime != "") form.operationTime = operationTime;
      form.SkipCount = 0;
      this.getDatas(form);
      this.currentPage = 1;
    },
    //客户列表选中
    customerSlelectionChange(val) {
      this.customerSlelection = val;
      console.log(this.customerSlelection);
    },
    //搜索列表一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val
      };
      let operationUser = this.operationLogSearchForm.operationUser;
      let operationTime = this.operationLogSearchForm.operationTime;
      if (operationUser != "") params.operationUser = operationUser;
      if (operationTime != "") params.operationTime = operationTime;
      this.getDatas(params);
    },
    //搜索列表跳转到指定页
    handleCurrentChange(val) {
      // this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = {};
      params.MaxResultCount = this.maxResultCount;
      params.SkipCount = skipCount;
      let operationUser = this.operationLogSearchForm.operationUser;
      let operationTime = this.operationLogSearchForm.operationTime;
      if (operationUser != "") params.operationUser = operationUser;
      if (operationTime != "") params.operationTime = operationTime;
      this.getDatas(params);
    }
  }
};
</script>

<style lang='scss' scoped>
.operationLogPage {
  //搜索条
  .searchBox {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .searchForm {
      display: flex;
      align-items: center;
      height: 60px;
      padding-left: 20px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
  //搜索列表
  .searchList {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    .searchListHead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding-left: 20px;
      background: #efefef;
      border-bottom: 1px solid #c5c5c5;
      .searchTitle {
        i {
          width: 24px;
          height: 24px;
          background: url("../../assets/imgs/search02.png");
        }
      }
      .searchListCtl {
        button,
        .el-select {
          width: 130px;
          margin-left: 10px;
        }
      }
    }
    .searchListContent {
      .detialSpan {
        color: #ff9400;
        cursor: pointer;
      }
    }
  }
}
</style>
